import { ArrowDownIcon, hitSlop, Icon, Shadows, View } from 'smoothie';

interface ScrollToBottomButtonProps {
    onPress: () => void;
}

export const ScrollToBottomButton = ({
    onPress,
}: ScrollToBottomButtonProps) => (
    <View
        testID="scroll-to-bottom-button"
        width={40}
        height={40}
        borderRadius={16}
        backgroundColor="$white"
        alignItems="center"
        justifyContent="center"
        onPress={onPress}
        cursor="pointer"
        animation="quick"
        animateOnly={['transform', 'opacity']}
        enterStyle={{ opacity: 0, scale: 0.9 }}
        pressStyle={{ scale: 0.95 }}
        {...hitSlop(8)}
        {...Shadows.CONVERSATIONAL}
    >
        <Icon icon={ArrowDownIcon} color="$black" size={24} />
    </View>
);
